"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var Svg = function Svg(_ref) {
  var src = _ref.src,
      props = _objectWithoutProperties(_ref, ["src"]);

  var _ref2 = props,
      rawSrc = _ref2.rawSrc,
      innerProps = _objectWithoutProperties(_ref2, ["rawSrc"]);

  if (!rawSrc) {
    throw new Error("Babel plugin 'react-optimized-image/plugin' not installed or this component could not be recognized by it.");
  }

  var SvgComponent = rawSrc.default || rawSrc;

  if (typeof SvgComponent !== 'function') {
    throw new Error("No react component generated. Please set `includeStrategy` option of optimized-images-loader to 'react'");
  }

  return /*#__PURE__*/_react.default.createElement(SvgComponent, innerProps);
};

var _default = Svg;
exports.default = _default;